import React, { useEffect, useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import { Link } from "react-router-dom";
import Footer from "../../component/Footer";

import "../../assets/new/css/MyDiary.css";
import "../../assets/new/css/SchoolTvChannel.css";
import "../../assets/new/css/library.css";
import "../../assets/new/css/wallet.css";
import { withTranslation } from "react-i18next";
import Params from "../../config/Params";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import InfiniteScroll from "react-infinite-scroll-component";
import { useTranslation } from "react-i18next";
import BreadCrumbs from "../../component/BreadCrumbs";
import SpinnerCmp from "../../component/SpinnerCmp";
import moment from "moment";
import i18next from "i18next";

const CashlessWallet = () => {
  const { i18n, t } = useTranslation();
  const [walletData, setWalletData] = useState([]);
  const [usd, setUsd] = useState({
    currency_code: "$500.00"
  });
  const [startDate, setStartDate] = useState("");
  const [endtDate, setEndDate] = useState("");
  const [selectedRange, setSelectedRange] = useState("");
  const [startDate1, setStartDate1] = useState(null);
  const [endDate1, setEndDate1] = useState(new Date());
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState("");
  const [messages, setMessages] = useState("");
  const [fromDateError, setFromDateError] = useState("");
  const [toDateError, setToDateError] = useState("");
  const [isProcessing, setisProcessing] = useState(false);

  // Static transaction data
  const staticTransactions = [
    {
      transaction_id: "1",
      transaction_type: "credit",
      transaction_amount: "100.00",
      date: "2023-05-15",
      time: "10:30",
      simple: "Deposit",
      color: "green"
    },
    {
      transaction_id: "2",
      transaction_type: "debit",
      transaction_amount: "50.00",
      date: "2023-05-14",
      time: "14:45",
      simple: "Cafeteria",
      color: "red"
    },
    {
      transaction_id: "3",
      transaction_type: "credit",
      transaction_amount: "200.00",
      date: "2023-05-10",
      time: "09:15",
      simple: "Deposit",
      color: "green"
    },
    {
      transaction_id: "4",
      transaction_type: "debit",
      transaction_amount: "30.00",
      date: "2023-05-08",
      time: "12:20",
      simple: "Bookstore",
      color: "red"
    },
    {
      transaction_id: "5",
      transaction_type: "credit",
      transaction_amount: "150.00",
      date: "2023-05-05",
      time: "16:10",
      simple: "Deposit",
      color: "green"
    },
    {
      transaction_id: "6",
      transaction_type: "debit",
      transaction_amount: "25.00",
      date: "2023-05-03",
      time: "11:30",
      simple: "Snacks",
      color: "red"
    },
    {
      transaction_id: "7",
      transaction_type: "credit",
      transaction_amount: "75.00",
      date: "2023-05-01",
      time: "13:45",
      simple: "Refund",
      color: "green"
    },
    {
      transaction_id: "8",
      transaction_type: "debit",
      transaction_amount: "40.00",
      date: "2023-04-28",
      time: "15:20",
      simple: "Supplies",
      color: "red"
    },
    {
      transaction_id: "9",
      transaction_type: "credit",
      transaction_amount: "125.00",
      date: "2023-04-25",
      time: "10:00",
      simple: "Deposit",
      color: "green"
    },
    {
      transaction_id: "10",
      transaction_type: "debit",
      transaction_amount: "35.00",
      date: "2023-04-20",
      time: "14:15",
      simple: "Printing",
      color: "red"
    }
  ];

  const WalletCash = (pages) => {
    setisProcessing(true);
    // Simulate API call with timeout
    setTimeout(() => {
      // For demo purposes, we'll just return the first 10 transactions initially
      const startIndex = (pages - 1) * 10;
      const endIndex = startIndex + 10;
      const paginatedData = staticTransactions.slice(startIndex, endIndex);
      
      setWalletData((prevdata) => [...prevdata, ...paginatedData]);
      setTotal(pages < 1 ? false : true); // Simulate pagination
      setisProcessing(false);
    }, 500);
  };

  const onPageLoad = () => {
    if (total !== false) {
      setPage(page + 1);
      let a = page + 1;
      WalletCash(a);
    }
  };

  useEffect(() => {
    WalletCash(1); // Initially load the first page of data
  }, []);

  useEffect(() => {
    if (startDate1 && endDate1) {
      walletCheck(); // Call walletCheck when startDate1 and endDate1 are updated
    }
  }, [startDate1, endDate1]);

  const walletFilter = () => {
    setFromDateError("");
    setToDateError("");

    // Validate the 'From' and 'To' dates
    if (!startDate) {
      setFromDateError("Please select a 'From' date.");
    }

    if (!endtDate) {
      setToDateError("Please select a 'To' date.");
    }

    // If any of the dates is missing, return early
    if (!startDate || !endtDate) {
      return;
    }

    // Check if the 'From' date is later than the 'To' date
    const start = new Date(startDate);
    const end = new Date(endtDate);

    if (start > end) {
      setFromDateError("The 'From' date cannot be later than the 'To' date.");
      setToDateError("The 'To' date cannot be earlier than the 'From' date.");
      return;
    }

    // Clear any previous error messages (if validation passes)
    setMessages("");

    // Simulate filtered data based on date range
    const filteredData = staticTransactions.filter(transaction => {
      const transDate = new Date(transaction.date);
      return transDate >= start && transDate <= end;
    });

    if (filteredData.length > 0) {
      setWalletData(filteredData);
    } else {
      setMessages("No transactions found for the selected date range.");
    }
  };

  const walletCheck = () => {
    setisProcessing(true);
    // Simulate API call with timeout
    setTimeout(() => {
      const start = new Date(startDate1);
      const end = new Date(endDate1);
      
      const filteredData = staticTransactions.filter(transaction => {
        const transDate = new Date(transaction.date);
        return transDate >= start && transDate <= end;
      });

      if (filteredData.length > 0) {
        setWalletData(filteredData);
      } else {
        setWalletData([]);
        setMessages("No transactions found for the selected period.");
      }
      setisProcessing(false);
    }, 500);
  };

  const handleRadioChange = (range) => {
    setSelectedRange(range);
    let newStartDate = new Date(); // Start with current date

    // Calculate the start date based on the selected range
    switch (range) {
      case "lastMonth":
        newStartDate.setMonth(newStartDate.getMonth() - 1);
        newStartDate.setDate(1); // First day of the previous month
        break;
      case "last3Months":
        newStartDate.setMonth(newStartDate.getMonth() - 3); // 3 months ago
        break;
      case "last6Months":
        newStartDate.setMonth(newStartDate.getMonth() - 6); // 6 months ago
        break;
      case "lastYear":
        newStartDate.setFullYear(newStartDate.getFullYear() - 1); // 1 year ago
        newStartDate.setMonth(0); // January
        newStartDate.setDate(1); // First day of the year
        break;
      default:
        newStartDate = new Date(); // Default to today if no range is selected
        break;
    }

    const formatDate = (date) => {
      return `${date.getFullYear()}/${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")}/${date.getDate().toString().padStart(2, "0")}`;
    };

    // Set the calculated startDate1 and the current endDate1 (current date)
    setStartDate1(formatDate(newStartDate));
    setEndDate1(formatDate(new Date()));
  };

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
    setFromDateError("");
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
    setToDateError("");
  };

  return (
    <>
      <div className="page-wrapper compact-wrapper" id="pageWrapper">
        <div className="page-body-wrapper sidebar-icon">
          <div className="page-body" id="container">
            <BreadCrumbs />

            <div class="library">
              <div>
                <div className="row">
                  <div>
                    <div className="col-md-6">
                      <label className="Balance">{t("Balance")}</label>
                    </div>
                    <div className="col-md-6">
                      <label className="walletcash">{usd.currency_code}</label>
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="books-main-wrapper">
                      <TabView>
                        <TabPanel
                          header={t("Last 10 Transactions")}
                          className="tabheadstyle"
                          headerStyle={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <InfiniteScroll
                            style={{
                              overflow: "hidden",
                            }}
                            dataLength={walletData?.length || 0}
                            next={onPageLoad}
                            hasMore={total !== false}
                            endMessage={
                              <p
                                style={{
                                  textAlign: "center",
                                  marginTop: "20px",
                                  marginBottom: "15px",
                                }}
                              >
                                {walletData.length > 0 ? (
                                  <b></b>
                                ) : (
                                  <b>{messages}</b>
                                )}
                              </p>
                            }
                          >
                            <div className="row">
                              {walletData?.map((item, index) => (
                                <div className="col-md-4" key={index}>
                                  <Link
                                    to={`/CashlessWallet/TransactionHistory?message=${encodeURIComponent(
                                      item.transaction_id
                                    )}&type=${encodeURIComponent(
                                      item.transaction_type
                                    )}`}
                                  >
                                    <div className="d-flex justify-content-between flex-row p-2 up1 rounded-3 shadow-sm walletcard">
                                      <div>
                                        <p className="walletdatetxt">
                                          {moment(item.time, "HH:mm").format(
                                            "hh:mm A"
                                          )}
                                          {"  "}
                                          {item.date}
                                        </p>
                                        <p
                                          style={{
                                            color: "#857E84",
                                            fontSize: "14px",
                                          }}
                                        ></p>
                                      </div>

                                      <div
                                        style={{
                                          flexDirection: "row",
                                          display: "flex",
                                        }}
                                      >
                                        <p
                                          style={{
                                            color: item.color,
                                            fontSize: "16px",
                                          }}
                                        >
                                          {item.simple}
                                        </p>
                                        <p
                                          className="walletamout"
                                          style={{
                                            color:
                                              item.transaction_type === "credit"
                                                ? "green"
                                                : "red",
                                          }}
                                        >
                                          {item.transaction_type === "credit"
                                            ? "+"
                                            : "-"}
                                          {item.transaction_amount}
                                        </p>
                                      </div>
                                    </div>
                                  </Link>
                                </div>
                              ))}
                            </div>
                          </InfiniteScroll>
                        </TabPanel>

                        <TabPanel
                          header={t("Detailed Transactions")}
                          className="tabheadstyle"
                          headerStyle={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <div className="row">
                            <div className="col-md-12">
                              <p className="Lorem-text lastmonth">
                                {t("For which period do you need a statement?")}
                              </p>
                            </div>
                            <div class="row">
                              <div class="col-6">
                                <div class="form-check">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    name="exampleRadios"
                                    id="exampleRadios1"
                                    value="lastMonth"
                                    checked={selectedRange === "lastMonth"}
                                    onChange={() =>
                                      handleRadioChange("lastMonth")
                                    }
                                  />
                                  <label
                                    class="form-check-label lastmonth"
                                    for="exampleRadios1"
                                  >
                                    {t("Last Month")}
                                  </label>
                                </div>
                                <div class="form-check">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    name="exampleRadios"
                                    id="exampleRadios2"
                                    value="last6Months"
                                    checked={selectedRange === "last6Months"}
                                    onChange={() =>
                                      handleRadioChange("last6Months")
                                    }
                                  />
                                  <label
                                    class="form-check-label  lastmonth"
                                    for="exampleRadios2"
                                  >
                                    {t("Last 6 months")}
                                  </label>
                                </div>
                              </div>
                              <div class="col-6">
                                <div class="form-check">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    name="exampleRadios"
                                    id="exampleRadios3"
                                    value="last3Months"
                                    checked={selectedRange === "last3Months"}
                                    onChange={() =>
                                      handleRadioChange("last3Months")
                                    }
                                  />
                                  <label
                                    class="form-check-label   lastmonth"
                                    for="exampleRadios3  lastmonth"
                                  >
                                    {t("Last 3 Months")}
                                  </label>
                                </div>
                                <div class="form-check">
                                  <input
                                    class="form-check-input"
                                    type="radio"
                                    name="exampleRadios"
                                    id="exampleRadios4"
                                    value="lastYear"
                                    checked={selectedRange === "lastYear"}
                                    onChange={() =>
                                      handleRadioChange("lastYear")
                                    }
                                  />
                                  <label
                                    class="form-check-label  lastmonth"
                                    for="exampleRadios4"
                                  >
                                    {t("Last Year")}
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="mt-3">
                            <p className="Lorem-text lastmonth">
                              {t("Or select a custom date of your choice")}
                            </p>
                            <div className="row">
                              <div className="form-group col-md-6  lastmonth">
                                <label for="task-title"> {t("From")}</label>
                                <input
                                  className="datepicker-here form-control digits"
                                  type="date"
                                  data-language="en"
                                  placeholder="MM-DD-YYYY"
                                  data-position="top left"
                                  onChange={handleStartDateChange}
                                />
                                {fromDateError && (
                                  <small className="error-message">
                                    {fromDateError}
                                  </small>
                                )}
                              </div>
                              <div className="form-group col-md-6  lastmonth">
                                <label for="task-title">{t("To")}</label>
                                <input
                                  className="datepicker-here form-control digits"
                                  type="date"
                                  data-language="en"
                                  placeholder="MM-DD-YYYY"
                                  data-position="top left"
                                  onChange={handleEndDateChange}
                                />
                                {toDateError && (
                                  <small className="error-message">
                                    {toDateError}
                                  </small>
                                )}
                              </div>
                            </div>
                          </div>
                          <div
                            className="col-12 btnshpro"
                            onClick={walletFilter}
                          >
                            <text className="btnshpro "> {t("PROCEED")}</text>
                          </div>
                        </TabPanel>
                      </TabView>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default CashlessWallet;